import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import { fromEvent, merge, Observable, of } from 'rxjs';
import { mapTo, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  public static instance: NetworkService | null = null;

  public onlineChanges$: Observable<boolean>;
  public connection$: Observable<'slow-2g' | '2g' | '3g' | '4g' | '5g'>;

  constructor(
    @Optional()
    protected router: Router,
    @Inject(PLATFORM_ID)
    protected platformId: string,
  ) {
    /* Store instance in a static property to allow access to injected services in the RxJS static operator
     * Should be done only once */
    if (!NetworkService.instance) {
      NetworkService.instance = this;
    }

    this.onlineChanges$ = isPlatformServer(this.platformId)
      ? of(true)
      : merge(fromEvent(window, 'online').pipe(mapTo(true)), fromEvent(window, 'offline').pipe(mapTo(false))).pipe(
          startWith(this.online),
        );

    if (isPlatformServer(this.platformId)) {
      return;
    }
    const connection = window.navigator['connection'];
    if (!connection) {
      return;
    }

    this.connection$ = new Observable((observer) => {
      const onConnectionChange = () => {
        const effectiveType = window.navigator['connection']['effectiveType'];
        observer.next(effectiveType);
      };
      onConnectionChange();
      window.navigator['connection'].addEventListener('change', onConnectionChange);
      return () => {
        window.navigator['connection'].removeEventListener('change', onConnectionChange);
        observer.complete();
      };
    });
  }

  get online(): boolean {
    return isPlatformBrowser(this.platformId) ? navigator.onLine : true;
  }
}
